// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getNotificationsActions } from './getNotificationsActions';
import { readAllNotificationsActions } from './readAllNotificationsActions';
import { readNotificationActions } from './readNotificationActions';
import { deleteNotificationsActions } from './deleteNotificationsActions';
import { getResetNotificationsActions } from './getResetNotificationsActions';

export default {
  getNotificationsActions,
  readAllNotificationsActions,
  readNotificationActions,
  getResetNotificationsActions,
  deleteNotificationsActions,
}
